export const apiPlaygroundStoreKey = 'apiPlaygroundOptions';
